import "./table.css";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import listValuations from "../methods/api/listValuations";
import { ValuationsListContext } from "../contextProviders/ValuationsListProvider";
import {
  AiOutlineDelete,
  AiOutlineClose,
} from "react-icons/ai";
import { confirmAlert } from "react-confirm-alert";
import deleteValuation from "../methods/api/deleteValuation";

const ValuationsTable = ({ user, authenticated }) => {
  const {
    valuationsList,
    setValuationsList,
    filteredValuationsList,
    setFilteredValuationsList,
  } = useContext(ValuationsListContext);

  useEffect(() => {
    listValuations().then((response) => {
      setValuationsList(response);
      setFilteredValuationsList(response);
    });
  }, []);

  const filterValuations = () => {
    setFilteredValuationsList(
      valuationsList.filter(
        (valuation) =>
          valuation.osoba_opracowujaca
            ?.toUpperCase()
            .includes(
              document.getElementById("formSearchbox").value.toUpperCase()
            ) ||
          `rjo4/${valuation.id}`
            .toUpperCase()
            .includes(
              document.getElementById("formSearchbox").value.toUpperCase()
            ) ||
          valuation.data_spotkania
            ?.toUpperCase()
            .includes(
              document.getElementById("formSearchbox").value.toUpperCase()
            )
      )
    );
  };

  return (
    <main>
      <h2 className="subpage-title">LISTA WYCEN</h2>
      <div className="table-wrapper">
        <input
          id="formSearchbox"
          placeholder="Proszę zacząć wpisywać tytuł w celu wyszukania wyceny..."
          onInput={() => {
            filterValuations();
          }}
        />
        <table className="fl-table valuations-table">
          <thead>
            <tr>
              <th>L.p.</th>
              <th>ID wyceny</th>
              <th>Data spotkania</th>
              <th>Osoba opracowująca</th>
              <th>Usuń</th>
            </tr>
          </thead>
          <tbody>
            {filteredValuationsList
              ?.slice(0)
              .reverse()
              .map((valuation, index) => (
                <TableRow
                  valuation={valuation}
                  index={index}
                  user={user}
                />
              ))}
          </tbody>
        </table>
      </div>
    </main>
  );
};

export default ValuationsTable;

const TableRow = ({ valuation, index, user }) => {
  const {
    valuationsList,
    setValuationsList,
    filteredValuationsList,
    setFilteredValuationsList,
  } = useContext(ValuationsListContext);

  const navigate = useNavigate();
  const [deleteIcon, setDeleteIcon] = useState(
    <AiOutlineDelete className="row-delete-icon" />
  );

  const handleDelete = (indeks) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="confirmation-modal-backdrop">
            <div className="confirmation-modal-content">
              <h1 className="modal-title">Usunąć wycenę?</h1>
              <p className="modal-message">Ta operacja jest nieodwracalna</p>
              <div className="modal-buttons">
                <button
                  className="modal-button modal-button-no"
                  onClick={onClose}
                >
                  NIE
                </button>
                <button
                  className="modal-button modal-button-yes"
                  onClick={() => {
                    deleteValuation(indeks).then((status) => {
                      if (status === 200) {
                        listValuations().then((response) => {
                          setValuationsList(response);
                          setFilteredValuationsList(response);
                        });
                      } else {
                        setDeleteIcon(
                          <AiOutlineClose className="fade-out" color="red" />
                        );
                      }
                      setTimeout(
                        () =>
                          setDeleteIcon(
                            <AiOutlineDelete className="row-delete-icon" />
                          ),
                        2000
                      );
                    });
                    onClose();
                  }}
                >
                  TAK
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <tr
      onClick={() => {
        navigate(`${process.env.PUBLIC_URL}/wycena?indeks=${valuation.indeks}`);
      }}
    >
      <td>{valuationsList.length - index}.</td>
      <td style={{ textAlign: "left" }}>RJO4/{valuation.id}</td>
      <td>{valuation.data_spotkania}</td>
      <td style={{ textAlign: "left" }}>{valuation.osoba_opracowujaca}</td>
      <td>
        <button
          className={"delete-row-button"}
          disabled={user.role !== 'admin'}
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(valuation.indeks);
          }}
        >
          {deleteIcon}{" "}
        </button>
      </td>
    </tr>
  );
};
